import React from "react";
import { IMaskInput } from "react-imask";

const Input = ({
  type = "text",
  value,
  name,
  placeholder,
  label,
  showLabel = true,
  fn,
  labelClass = "",
  inputClass = "",
  hasValidationError = false,
  onLeave,
  mask,
  ...rest
}) => {
  const className = `form-control ${inputClass} ${
    hasValidationError ? "is-invalid" : ""
  }`;

  const handleBlur = (e) => {
    if (onLeave) onLeave(e);
  };

  if (mask) {
    return (
      <div className="w-100">
        {showLabel && label && (
          <label className={labelClass} htmlFor={name}>
            {label}
          </label>
        )}
        <IMaskInput
          {...rest}
          id={name}
          name={name}
          type={type}
          mask={mask}
          value={value}
          onAccept={(val) => fn && fn(val)}
          placeholder={placeholder}
          className={className}
          onBlur={handleBlur}
        />
      </div>
    );
  }

  return (
    <div className="w-100">
      {showLabel && label && (
        <label className={labelClass} htmlFor={name}>
          {label}
        </label>
      )}
      <input
        {...rest}
        id={name}
        name={name}
        type={type}
        value={value}
        placeholder={placeholder}
        className={className}
        onChange={(e) => fn && fn(e.target.value)}
        onBlur={handleBlur}
      />
    </div>
  );
};

export default Input;
